// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2O-2z","savePackageButton":"ClientWallet_savePackageButton__3ON1Q"};